// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mpju","footer":"styles_footer__cqh3W"};